import { render, staticRenderFns } from "./badge.vue?vue&type=template&id=0511ec58&scoped=true&"
import script from "./badge.vue?vue&type=script&lang=ts&"
export * from "./badge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0511ec58",
  null
  
)

export default component.exports